import React from "react";
import "../Css/Landing.css";

export default function Landing() {
  return (
    <div className="todo">
      <div>
        <h1 className="title4"> </h1>
        <div className="loader"></div>
      </div>
    </div>
  );
}
